import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdAddShoppingCart, MdArrowBackIos, MdClose, MdDateRange, MdDone, MdFileDownload, MdHistory, MdOutlineInventory, MdOutlineLocalPrintshop, MdPrint, MdReport, MdSearch } from "react-icons/md";
import QRCode from "../../components_root/QRCode.jsx";
import ShareButton from "../../components_root/ShareButton.jsx";
import { Timestamp } from "firebase/firestore";
import Print_receipt_order from "../print_root/print_receipt_order.js";
import Ledger_accounts_reports_profile from "../../company_root/staff_account_root/ledger_accounts_reports_profile.jsx";
import Settingprint_popup from "../print_setting_root/settingprint_popup.jsx";
import Print_receipt_a4 from "../print_root/print_receipt_a4.js";
import CopyUID from "../../components_root/copyuid.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Stock_inventory() {
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [amount, setAmount] = useState(0);
    const [transaction, setTransaction] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [voucherlist, setVoucherlist] = useState([]);
    const [voucherselected, setVoucherselected] = useState("All Reports");
    const [reportsrata, setReportsData] = useState([]);
    const [printpage, setPrintpage] = useState("reports");
    const [printapply, setPrintapply] = useState("");
    const [printid, setPrintid] = useState("");
    const navigate = useNavigate();
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    const servicetablename = "accountingfinancedb";
    const [settingprintopen, setSettingprintopen] = useState(false);
    const [select_company_uid, setSelect_company_uid] = useState(null);
    const [guid, setGuid] = useState(null);

    useEffect(() => {
        setGuid(Cookies.get("guid"));
    }, []);

    useEffect(() => {
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    //
    useEffect(() => {

        const today = new Date();
        const firstDay =
            today.getFullYear() +
            "-" +
            String(today.getMonth() + 1).padStart(2, "0") +
            "-01";
        const currentDay = today.toISOString().slice(0, 10);
        setFrom_date(firstDay);
        setTo_date(currentDay);
    }, []);


    useEffect(() => {
        if (!select_company_uid || !guid || !printpage) return;

        const applyQuery = query(
            collection(
                db,
                servicetablename,
                select_company_uid,
                "print_settings_account_apply"
            ),
            where("guid", "==", guid),
            where("status", "==", true),
            where("printpage", "==", printpage)
        );

        const unsubscribe = onSnapshot(
            applyQuery,
            (snapshot) => {
                if (snapshot.empty) {
                    setPrintapply(null);
                    return;
                }
                setPrintapply(snapshot.docs[0]?.data()?.printsize ?? null);
                setPrintid(snapshot.docs[0]?.data()?.printid ?? null);
            },
            (error) => {
                console.error("Print apply listener error:", error);
                setPrintapply(null);
            }
        );

        return unsubscribe;
    }, [select_company_uid, guid, printpage]);

    const get_Reports = () => {
        if (!select_company_uid || !from_date || !to_date) return;

        setIsLoading2(true);

        const startTimestamp = Timestamp.fromDate(new Date(`${from_date}T00:00:00`));
        const endTimestamp = Timestamp.fromDate(new Date(`${to_date}T23:59:59`));

        const stockRef = collection(
            db,
            servicetablename,
            select_company_uid,
            "voucher_print_stock"
        );

        const constraints = [
            where("date_time", ">=", startTimestamp),
            where("date_time", "<=", endTimestamp),
            orderBy("date_time", "desc"),
        ];

        if (voucherselected && voucherselected !== "All Reports") {
            constraints.splice(2, 0, where("voucher", "==", voucherselected));
        }

        const stockQuery = query(stockRef, ...constraints);

        const unsubscribe = onSnapshot(
            stockQuery,
            async (snapshot) => {

                const printRef = collection(
                    db,
                    servicetablename,
                    select_company_uid,
                    "voucher_print"
                );

                // 🔹 Fetch stock data
                const stockData = snapshot.docs.map(d => ({
                    id: d.id,
                    ...d.data(),
                }));

                // 🔹 Fetch print data & merge
                const mergedData = await Promise.all(
                    stockData.map(async (stock) => {
                        if (!stock.voucherprintid) {
                            return { ...stock, print: null };
                        }

                        const q = query(
                            printRef,
                            where("voucherprintid", "==", stock.voucherprintid)
                        );

                        const snap = await getDocs(q);

                        let printData = null;
                        snap.forEach(doc => {
                            printData = {
                                id: doc.id,
                                ...doc.data(),
                            };
                        });

                        return {
                            ...stock,
                            print: printData
                        };
                    })
                );

                // 🔹 Totals
                const totalAmount = mergedData.reduce(
                    (sum, v) => sum + Number(v?.totalamount || 0),
                    0
                );

                // 🔹 State updates
                setReportsData(mergedData);
                setTransaction(mergedData.length);
                setAmount(totalAmount);

                setVoucherlist(prev => {
                    const set = new Set(prev);
                    mergedData.forEach(v => v?.voucher && set.add(v.voucher));
                    return Array.from(set);
                });

                setIsLoading2(false);
            },
            (error) => {
                console.error("Report error:", error);
                setIsLoading2(false);
            }
        );

        return unsubscribe;
    };


    useEffect(() => {
        const unsub = get_Reports();
        return () => unsub && unsub();
    }, [select_company_uid, from_date, to_date, voucherselected]);


    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const downloadPDF = () => {
        if (!reportsrata || reportsrata.length === 0) return;

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Function to draw header, top line, and footer
        const drawHeaderAndFooter = (data) => {
            // Top full-width line
            // doc.setDrawColor(0); // Black color
            // doc.setLineWidth(0.5);
            // doc.line(14, 12, pageWidth - 14, 12);

            // Title
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text("Reports Report", 14, 15);

            // Date (right side)
            doc.setFontSize(10);
            const dateText = "Report: " + new Date().toLocaleString();
            const textWidth = doc.getTextWidth(dateText);
            doc.text(dateText, pageWidth - textWidth - 16, 15);
            doc.setFont("helvetica", "normal");
            const Amounttext = "Amount: " + amount + "/-";
            const Transactiontext = "Trans: " + transaction + ", " + Amounttext;
            doc.text(Transactiontext, pageWidth - textWidth - 16, 20);
            //


            // doc.text(Amounttext, pageWidth - textWidth - 14, 23);

            // Bottom line above footer
            doc.setLineWidth(0.1);
            doc.line(14, pageHeight - 18, pageWidth - 14, pageHeight - 18);

            // Page number (center bottom)
            const pageNum = `Page ${doc.internal.getNumberOfPages()}`;
            doc.setFontSize(8);
            doc.text(pageNum, pageWidth / 2, pageHeight - 14, { align: "center" });

            // Footer text (Supported by: Aooz.in)
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Supported by: Aooz.in", pageWidth / 2, pageHeight - 8, { align: "center" });
        };

        // Table Data
        const tableData = reportsrata.map((row) => [
            row.tokennumber || "",
            row.date_time?.toDate?.().toLocaleString() || "",
            row.vouchernumber || "",
            row.voucher || "",
            row.totalamount?.toFixed(2) || "0.00" // formatted amount
        ]);

        // AutoTable with multiple pages
        autoTable(doc, {
            startY: 25,
            head: [["Token", "Date-Time", "Voucher no", "Voucher", "Amount"]],
            body: tableData,
            headStyles: {
                fillColor: [37, 99, 235],
                textColor: 255,
                fontStyle: "bold"
            },
            alternateRowStyles: {
                fillColor: [244, 245, 248]
            },
            styles: {
                font: "helvetica",
                fontSize: 9
            },
            columnStyles: {
                4: { halign: "right" } // Right-align Amount
            },
            didDrawPage: drawHeaderAndFooter
        });

        doc.save("voucher_report.pdf");
    };



    const [voucherprintid, setVoucherprintid] = useState();

    const PrintReceiptVoucher = (id) => {
        setVoucherprintid(id);
        const timer = setTimeout(() => {
            setVoucherprintid("");
        }, 2000);
    };
    const timeAgo = (date) => {
        const seconds = Math.floor((new Date() - date) / 1000);

        const intervals = [
            { label: "yer", seconds: 31536000 },
            { label: "moth", seconds: 2592000 },
            { label: "day", seconds: 86400 },
            { label: "hrs", seconds: 3600 },
            { label: "min", seconds: 60 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(seconds / interval.seconds);
            if (count >= 1) {
                return `${count} ${interval.label}${count > 1 ? "" : ""} ago`;
            }
        }
        return "Just now";
    };
    const getAgoDays = (date) => {
        const start = new Date(date);
        const now = new Date();

        const diffTime = now - start;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 1;
    };

    const get_calculateAmount = (row) => {
        if (!row?.date_time?.toDate) return Number(row.total_amount || 0);

        const days = getAgoDays(row.date_time.toDate());

        // if perday is inside items array
        const isPerDay = Array.isArray(row.items)
            ? row.items.some(i => i.perday === true)
            : row.perday === true;

        return isPerDay
            ? Number(row.total_amount || 0) * days
            : Number(row.total_amount || 0);
    };
    return (
        <div >


            <div className="items-back">
                <div className="b-bottom">
                    <table>
                        <tr>
                            <td ><div

                                className="button-ui0 text-h2 bold p-2"
                            >
                                <MdOutlineInventory className="icon" />Stock inventory
                            </div></td>
                            <td width={30}>
                                <div

                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div className="post-container p-2">
                    <div className="ui-grid">
                        <div className="ui-items items-back p-2">
                            <table>
                                <tr>
                                    <td className="text-h2">Items</td>
                                    <td>  <div className="text-h2 bold">{transaction}</div></td>
                                </tr>
                                <tr>
                                    <td className="text-h2">Amount</td>
                                    <td>  <div className="text-h2 bold">₹{amount}/-</div></td>
                                </tr>
                            </table>
                        </div>
                        <div className="ui-items items-back p-2">
                            <select className="text-h2 bold p-11" onChange={(e) => setVoucherselected(e.target.value)}>
                                <option value={"All Reports"}>All Reports</option>
                                {voucherlist.map((item, index) => (
                                    <option key={index} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                            <table>
                                <tr>
                                    <td>
                                        <input
                                            value={from_date}
                                            type="date"
                                            onChange={(e) => setFrom_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <input
                                            value={to_date}
                                            type="date"
                                            onChange={(e) => setTo_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <div
                                            onClick={() => get_Reports()}

                                            className="button-ui2 p-1">
                                            <MdSearch className="icon cursor" />
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div className="ui-items items-back p-22 cursor fill">

                        </div>
                        <div className="ui-items items-back p-11">
                            <table>
                                <tr>
                                    <td>
                                        <div className="button-ui2 p-1 cursor" title="Download PDF"
                                            onClick={downloadPDF}

                                        >
                                            <MdFileDownload className="icon cursor" />PDF Download
                                        </div>
                                    </td>
                                    <td width={100}>
                                        <div className="button-ui p-1 cursor"
                                            onClick={() => {
                                                setSettingprintopen(true);
                                            }}
                                        >
                                            <MdOutlineLocalPrintshop className="icon cursor" />Set <div className="bold">{printapply}</div>
                                        </div>
                                    </td>
                                </tr>
                            </table>


                        </div>
                    </div>

                </div>
                <div className="post-container p-2">
                    <div className="ui-grid">
                        {IsLoading2 ? null : !reportsrata || reportsrata.length === 0 ? (
                            <div className="text-h2 bold p-5">No voucher Found</div>
                        ) : (
                            <>
                                {reportsrata.map((row) => (
                                    <div key={row.voucherprintid}
                                        className="ui-items b-1 rounded">
                                        <table

                                        >
                                            <tbody><tr className="b-bottom p-11" >
                                                       <td className="bold  text-h2 fcap p-2">{row.print.voucher_type}</td>
                                                    <td className="bold fcap text-h2">{row.print.voucher || "voucher"}</td>
                                                  <td colSpan={2} className="text-h3 p-2 text-r">
                                                        {row.date_time?.toDate ? (
                                                            <>
                                                                {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                {row.date_time.toDate().toLocaleTimeString()}
                                                            </>
                                                        ) : (
                                                            "No date"
                                                        )}
                                                    </td>
                                                 </tr>
                                                <tr >
                                                    <td width={20} className="text-h3 text-off p-11">
                                                        Name
                                                    </td>
                                                    <td className="bold text-h2">  {row.print.namepaying || "0"}</td>
                                                </tr>
                                                <tr >
                                                    <td width={20} className="text-h3 text-off p-11">
Mobile
                                                    </td>
                                                    <td>  {row.print.mobile || "0"}</td>
                                                </tr>
                                                   <tr >
                                                    <td width={20} className="text-h3 text-off p-11">
 
                                                    </td>
                                                    <td>  {row.print.address || ""}</td>
                                                </tr>
                                                {/* Token & Voucher */}
                                                <tr  >
                                                    <td width={30} className="bold text-h2 p-11">#
                                                        {row.print.tokennumber || "0"}
                                                    </td>
                                                    <td >
                                                        <div className="button-ui0">
                                                            {row.vouchernumber || "0"}
                                                            <CopyUID id={row.vouchernumber} />
                                                        </div>
                                                    </td>
                                                </tr>

                                             

                                                {/* Amount & Share */}
                                                <tr > 
                                                    <td className="bold fcap p-11">Paid</td>
                                                    <td className="bold">₹{row.print.totalamount || 0}/-</td>
                                                    <td align="right p-11">
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div
                                                                            className={`button-ui bold ${row.status === true ? "red-back " : "green-back"
                                                                                }`}
                                                                        >
                                                                            {row.status === true
                                                                                ? row.date_time?.toDate
                                                                                    ? timeAgo(row.date_time.toDate())
                                                                                    : "No date"
                                                                                : "Close"}
                                                                        </div>
                                                                    </td>

                                                                    <td className="bold text-h2" align="right">
                                                                        Bill ₹{get_calculateAmount(row)}/-
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table> 
                                                    </td>
                                                </tr>

                                                {/* Print */}
                                                <tr className="items-back-fill p-11">
                                                 <td className="bold text-h2 fcap p-11">{row.print.voucher_type}</td>
                                                    <td  >
                                                        <div
                                                            className="button-ui0 cursor"
                                                            onClick={() =>
                                                                PrintReceiptVoucher(row.voucherprintid)
                                                            }
                                                        >
                                                            <MdPrint className="icon" />
                                                        </div>
                                                    </td>
                                                    <td align="right">
                                                        <ShareButton url={row.slug} />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div>
                                            <table className="table_padding">

                                                <tbody>

                                                    {Array.isArray(row?.items) &&
                                                        row.items.map((item, index) => (
                                                            <tr key={index}>
                                                                <td className="bold fcap">{item.title}</td>
                                                                <td className="fcap">{item.itemname}</td>
                                                                <td className="bold fcap">{item.perday ? "Per Day" : "Price"}</td>
                                                                <td className="bold fcap">₹{item.price}</td>
                                                                <td className="bold fcap">{item.qty}</td>
                                                                <td className="bold fcap text-r">₹{item.amount}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                    </div>

                </div>
            </div>
            {voucherprintid && printapply == "4INCH" && (
                <Print_receipt_order voucherprintid={voucherprintid} printid={printid} />
            )}
            {voucherprintid && printapply == "A4" && (
                <Print_receipt_a4 voucherprintid={voucherprintid} printid={printid} />
            )}
            <Settingprint_popup data={printpage} isOpen={settingprintopen} onClose={() => setSettingprintopen(false)} />
        </div>
    );
}
